export default "__VITE_ASSET__d103578c__"